import { Button, IconAlert, IconLogOut, useLocalization } from '@magicdoorinc/ui';
import { createSignal } from 'solid-js';
import { useAuth } from '~/contexts/global';
import { getPublicFileURL } from '~/utils/prefix';
import { TrialPaymentMethodModal } from './TrialPaymentMethodModal';

const TrialLockout = () => {
  const { t } = useLocalization();
  const { signOut } = useAuth();

  const [showPaymentModal, setShowPaymentModal] = createSignal<boolean>(false);

  const handlePaymentSuccess = () => {
    setShowPaymentModal(false);
  };

  return (
    <div>
      <div class="relative flex min-h-screen flex-col justify-center overflow-hidden bg-gradient-dark-purple-blue px-3 py-8 sm:px-6 lg:bg-[linear-gradient(90deg,_#7919C5_50%,_#2B1EC0_100%)] lg:px-8">
        <img
          src={getPublicFileURL('/logoFull.png')}
          alt="Logo"
          class="absolute right-4 top-4 h-12 w-auto sm:right-6 sm:top-6 sm:h-16 lg:right-8 lg:top-8 lg:h-20"
        />

        <div class="relative mx-auto w-full max-w-md sm:max-w-lg lg:max-w-xl">
          <div class="relative overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-white/20 backdrop-blur-sm">
            <div class="border-b-4 px-6 py-8 sm:px-8 sm:py-10">
              <div class="text-center">
                <div class="mx-auto flex size-16 items-center justify-center rounded-full bg-red-100 shadow-lg ring-4 ring-red-50 sm:size-20">
                  <IconAlert class="size-8 text-red-600 sm:size-10" />
                </div>

                <h1 class="mt-6 text-2xl font-bold capitalize text-text-01 sm:text-3xl lg:text-4xl">{t('Trial period expired')}</h1>

                <p class="mt-4 text-sm leading-relaxed text-text-02 sm:text-base lg:text-lg">
                  {t('Your trial period has expired, please add a payment method to continue using the application')}
                </p>
              </div>
            </div>

            <div class="px-6 py-8 sm:px-8 sm:py-10">
              <div class="flex flex-col items-center justify-center text-center">
                <Button
                  onClick={() => setShowPaymentModal(true)}
                  class="w-full justify-center px-8 py-4 text-base shadow-lg transition-all duration-200 hover:scale-105 hover:shadow-xl active:scale-95">
                  {t('Add payment method')}
                </Button>

                <p class="mt-4 text-xs text-text-02 sm:text-sm">{t('Secure payment processing powered by industry-leading providers')}</p>

                <Button
                  onClick={signOut}
                  variant="text"
                  class="mt-4 w-fit justify-center gap-2 px-8 py-2 text-sm text-text-02 transition-all duration-200 hover:bg-gray-50 hover:text-text-01">
                  <IconLogOut class="size-4" />
                  {t('Sign out')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TrialPaymentMethodModal visible={showPaymentModal()} onClose={() => setShowPaymentModal(false)} onSuccess={handlePaymentSuccess} />
    </div>
  );
};

export default TrialLockout;
